module.exports = __webpack_public_path__ + "static/lk-d53b60dcb8dd847bd8c1f8d7514155a7.svg";